import React from 'react'

import { Link } from 'gatsby'

import styles from './Footer.module.css'

import logo from '../../images/ww-logo.jpg'

import { Grid } from '@material-ui/core'

const Footer = () => {
  return (
    <>
      <footer>
        <Grid
          container
          className="bgWhite"
          alignItems="center"
          justify="center"
        >
          <Grid item xs={12} md={10} lg={8} className={styles.footerContainer}>
            <img src={logo} alt="wood wizards logo" />

            <div className={styles.linksContainer}>
              <div className={styles.links}>
                <h4>Links</h4>
                <Link to="/">Home</Link>
                <Link to="/about">About</Link>
                <Link to="/products">Products</Link>
                <Link to="/contact">Contact</Link>
              </div>
              <div className={styles.links}>
                <h4>Legal</h4>
                <Link to="/terms">Terms & Conditions</Link>
                <Link to="/about">Privacy Policy</Link>
              </div>
              <div className={styles.links}>
                <h4>Our Address</h4>
                <p>7 Swaffham Rd</p>
                <p>Narborough</p>
                <p>King's Lynn</p>
                <p>PE32 1TB</p>
              </div>
            </div>
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          justify="center"
          className={styles.copy}
        >
          <Grid item xs={12} md={10} lg={8} className={styles.copyContainer}>
            <p>Copyright Wood Wizards. All rights reserved.</p>

            <p>
              Designed by <Link to="/">Aaron Duke</Link>
            </p>
          </Grid>
        </Grid>
      </footer>
    </>
  )
}

export default Footer
